import { render } from "./HomeAdmin.vue?vue&type=template&id=b8603490"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__